import React from 'react';
import { useTranslation } from '@/src/i18n';

import DocumentUploadForm from '@/components/templates/Document/DocumentUploadForm';
import Dialog from '@/components/molecules/Dialog/Dialog';

const ShareDocumentUpload = ({ uploadDocument, endSharing }) => {
  const { t } = useTranslation();

  return (
    <Dialog
      open
      onClose={endSharing}
      title={t('share-prescription-upload-title')}
      transitionDuration={{ enter: 0 }}
      className="popup"
    >
      <DocumentUploadForm
        onUpload={uploadDocument}
        onSuccess={endSharing}
        tlc={false}
        onCancel={endSharing}
      />
    </Dialog>
  );
};

export default ShareDocumentUpload;
